export const translations = {
  en: {
    // Navigation
    nav: {
      home: "Home",
      aboutMe: "About Me",
      projects: "Projects",
      miniProjects: "Mini Projects",
      tests: "Tests",
      javascript30: "Javascript 30",
    },
    // Projects page
    projects: {
      title: "Projects",
      professional: "Professional",
      others: "Others",
      filters: {
        stack: "Stack:",
        category: "Category:",
        frontend: "Frontend",
        backend: "Backend",
        fullstack: "Fullstack",
        clear: "Clear Filters",
      },
      noResults: "No projects found matching the selected filters.",
    },
    // Tests page
    tests: {
      title: "Tests",
      noResults: "No test projects found.",
      certificate: "Certifications",
      viewCertificate: "View Certificate",
      viewReport: "View Test Report",
      viewActions: "View Test Actions",
    },
    // Project detail page
    projectDetail: {
      details: "Details",
      role: "Role:",
      problems: "Problems:",
      solutions: "Solutions:",
      visitSite: "Visit Site",
      visitGitHub: "Visit GitHub Repository",
      projectNotFound: "Project not found",
      projectNotFoundDesc: "The project you're looking for doesn't exist.",
    },
    // About Me
    aboutMe: {
      downloadResume: "Download Resume",
      title: "Full-Stack Developer | ",
      paragraph1:
        "I'm a full-stack developer with a passion for creating clean, responsive, and user-friendly applications. I've been coding since 2021, working with HTML, CSS, JavaScript, TypeScript, and frameworks like React, Vue, and Ruby on Rails. Along the way, I've also explored Node.js, Express, PostgreSQL, AWS, Firebase, and API integrations.",
      paragraph2: "I started my career with a six-month internship at",
      kammekoLink: "Kammeko",
      paragraph2AfterKammeko: "as a front-end developer using React. After that, I joined",
      hivelocityLink: "HiVelocity",
      paragraph2AfterHivelocity: "where I gained extensive experience with Vue.js, React, and Ruby on Rails. I then moved to",
      cesantaLink: "Cesanta",
      paragraph2AfterCesanta: "where I built a dashboard for embedded developers using vanilla JavaScript. Currently, I'm part of the",
      revaLink: "Reva",
      paragraph2Final: "team as a Full-Stack Ruby on Rails Developer, building and maintaining web applications.",
      paragraph3:
        "I also worked as a soccer scout/data analyst for Stats Perform, an experience that strengthened my attention to detail, organization, and ability to interpret data, all of which I now bring into my development work. I value collaborative teams, supportive work cultures, and continuous learning. Whether it's solving a tricky bug, exploring new tech, or helping a teammate, I'm always driven by curiosity and the desire to do better.",
      signature: "Renato Delboni",
    },
    // Common
    common: {
      offline: "Offline",
      online: "Online",
      privateRepo: "Private Repository",
      new: "New",
    },
  },
  pt: {
    // Navigation
    nav: {
      home: "Início",
      aboutMe: "Sobre Mim",
      projects: "Projetos",
      miniProjects: "Mini Projetos",
      tests: "Testes",
      javascript30: "Javascript 30",
    },
    // Projects page
    projects: {
      title: "Projetos",
      professional: "Profissional",
      others: "Outros",
      filters: {
        stack: "Stack:",
        category: "Categoria:",
        frontend: "Frontend",
        backend: "Backend",
        fullstack: "Fullstack",
        clear: "Limpar Filtros",
      },
      noResults: "Nenhum projeto encontrado com os filtros selecionados.",
    },
    // Tests page
    tests: {
      title: "Testes",
      noResults: "Nenhum projeto de teste encontrado.",
      certificate: "Certificações",
      viewCertificate: "Ver Certificado",
      viewReport: "Ver Relatório de Teste",
      viewActions: "Ver Ações de Teste",
    },
    // Project detail page
    projectDetail: {
      details: "Detalhes",
      role: "Função:",
      problems: "Problemas:",
      solutions: "Soluções:",
      visitSite: "Visitar Site",
      visitGitHub: "Visitar Repositório GitHub",
      projectNotFound: "Projeto não encontrado",
      projectNotFoundDesc: "O projeto que você está procurando não existe.",
    },
    // About Me
    aboutMe: {
      downloadResume: "Baixar Currículo",
      title: "Desenvolvedor Full-Stack | ",
      paragraph1:
        "Sou um desenvolvedor full-stack com paixão por criar aplicações limpas, responsivas e fáceis de usar. Estou programando desde 2021, trabalhando com HTML, CSS, JavaScript, TypeScript e frameworks como React, Vue e Ruby on Rails. Ao longo do caminho, também explorei Node.js, Express, PostgreSQL, AWS, Firebase e integrações de API.",
      paragraph2: "Comecei minha carreira com um estágio de seis meses na",
      kammekoLink: "Kammeko",
      paragraph2AfterKammeko: "como desenvolvedor front-end usando React. Depois disso, entrei na",
      hivelocityLink: "HiVelocity",
      paragraph2AfterHivelocity: "onde ganhei ampla experiência com Vue.js, React e Ruby on Rails. Em seguida, me mudei para a",
      cesantaLink: "Cesanta",
      paragraph2AfterCesanta: "onde construí um dashboard para desenvolvedores embarcados usando JavaScript puro. Atualmente, faço parte da equipe",
      revaLink: "Reva",
      paragraph2Final: "como Desenvolvedor Full-Stack Ruby on Rails, construindo e mantendo aplicações web.",
      paragraph3:
        "Também trabalhei como scout/analista de dados de futebol para a Stats Perform, uma experiência que fortaleceu minha atenção aos detalhes, organização e capacidade de interpretar dados, tudo isso que agora trago para o meu trabalho de desenvolvimento. Valorizo equipes colaborativas, culturas de trabalho de apoio e aprendizado contínuo. Seja resolvendo um bug complicado, explorando novas tecnologias ou ajudando um colega, sempre sou impulsionado pela curiosidade e pelo desejo de fazer melhor.",
      signature: "Renato Delboni",
    },
    // Common
    common: {
      offline: "Offline",
      online: "Online",
      privateRepo: "Repositório Privado",
      new: "Novo",
    },
  },
};

export const getTranslation = (language, key) => {
  const keys = key.split(".");
  let value = translations[language];

  for (const k of keys) {
    value = value?.[k];
  }

  return (
    value || translations.en[key.split(".")[0]]?.[key.split(".")[1]] || key
  );
};
